import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { RainbowFirebaseApp } from '@rainbow-modules/app';
import { WhenAuthenticated, WhenNoAuthenticated } from '@rainbow-modules/auth';
import RenderIf from 'react-rainbow-components/components/RenderIf';
import Spinner from 'react-rainbow-components/components/Spinner';
import RedirectToAuth from './redirectToAuth';
import getFirebaseCookieToken from '../../services/getFirebaseCookieToken';
import startApplication from '../../actions/startApplication';
import { SpinnerContainer, AppLogo } from './styled';

function initApp(app) {
  if (!getFirebaseCookieToken()) {
    app.auth().signOut();
  }
}

function AppSpinner() {
  return /*#__PURE__*/React.createElement(Spinner, {
    type: "arc",
    variant: "brand",
    size: "x-large"
  }, /*#__PURE__*/React.createElement(AppLogo, null));
}

export default function EvertransitApp(props) {
  var app = props.app,
      reducers = props.reducers,
      translations = props.translations,
      children = props.children,
      theme = props.theme;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isInitializing = _useState2[0],
      setIsInitializing = _useState2[1];

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return startApplication(app);

            case 2:
              setIsInitializing(false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [app]);
  return /*#__PURE__*/React.createElement(RainbowFirebaseApp, {
    app: app,
    theme: theme,
    locale: "en",
    initialize: function initialize() {
      return initApp(app);
    },
    spinner: /*#__PURE__*/React.createElement(AppSpinner, null),
    reducers: reducers,
    translations: translations
  }, /*#__PURE__*/React.createElement(WhenAuthenticated, {
    path: "/",
    redirect: "/signin"
  }, children), /*#__PURE__*/React.createElement(WhenNoAuthenticated, {
    path: "/signin"
  }, /*#__PURE__*/React.createElement(RenderIf, {
    isTrue: !isInitializing
  }, /*#__PURE__*/React.createElement(RedirectToAuth, null)), /*#__PURE__*/React.createElement(RenderIf, {
    isTrue: isInitializing
  }, /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
    type: "arc",
    size: "x-large",
    variant: "brand"
  }, /*#__PURE__*/React.createElement(AppLogo, null))))));
}
EvertransitApp.defaultProps = {
  app: undefined,
  children: undefined,
  reducers: undefined,
  translations: undefined,
  theme: undefined
};